import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/Card';
import { Users } from "lucide-react";
const PopularUserLocations = ({ userLocations }) => {

  return (
    <Card className="lg:col-span-2 shadow-elegant">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5 text-primary" />
          En Popüler Kullanıcı Konumları
        </CardTitle>
        <CardDescription>Kitlenizin coğrafi dağılımı</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {userLocations && userLocations.map((location, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-gradientPrimary rounded-full flex items-center justify-center text-white text-sm font-semibold">
                    {index + 1}
                  </div>
                </div>
                <div>
                  <p className="font-medium">{location.country}</p>
                  <p className="text-sm text-mutedForeground">
                    {location.users.toLocaleString()} kullanıcı
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-24 bg-muted rounded-full h-2">
                  <div
                    className="h-2 bg-gradientPrimary rounded-full transition-all duration-500"
                    style={{ width: `${location.percentage}%` }}
                  />
                </div>
                <span className="text-sm font-semibold w-8">
                  {location.percentage}%
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}

export default PopularUserLocations